import { useQuery } from '@tanstack/vue-query';
import { computed, type Ref } from 'vue';

import type { FormalizationApi } from '~/services/formalization-api/formalization-api.types';

import formalizationApi from '~/services/formalization-api/formalization-api';

export default function useInstallments(financingId: Ref<null | number | undefined>) {
  const queryKey = computed(() => ['installments', financingId.value]);

  const queryFn = async (): Promise<FormalizationApi.GetInstallmentsResponse | null> => {
    if (!financingId.value) return null;

    return formalizationApi.getInstallments({ financingId: financingId.value });
  };

  return useQuery({
    enabled: computed(() => Boolean(financingId.value)),
    queryFn,
    queryKey,
    retry: 3,
  });
}
